import { useTranslation } from '@thoughtspot/i18n';
import { BannerAlertType } from '@thoughtspot/radiant-react/widgets/alert';
import React, { useEffect, useMemo, useState } from 'react';
import { useGetRevSshQuery, useSetRevSshMutation, } from "../../../../services/system/system-service";
import { Content, Seperator } from '../../common';
import { ActionButtons, LearnMore, Mode } from '../../common/constants';
import { getConfig } from '../../common/form-builder-config';
import { getFormFields, parseFormData } from '../../common/utils';
import { TranslationsKeys } from '../constants';
import styles from '../security.module.scss';
export const RevSshComponent = ({ pageName, mode, setMode, formType, setFormType, showLoader, hideLoader, onSuccess, onError, }) => {
    const { t } = useTranslation();
    const InitialSshConfig = useMemo(() => getConfig('ssh'), []);
    const [sshData, setSshData] = useState({});
    const [sshFormFields, setSshFormFields] = useState([]);
    const [sshPostData, setSshPostData] = useState(null);
    const { data: sshResponse, loading: isSshLoading, error: sshError, } = useGetRevSshQuery();
    const getFieldConfig = (field) => {
        switch (field.key) {
            default:
                return field.config;
        }
    };
    const getAdditionlFieldAttribute = (field) => {
        switch (field.key) {
            case 'reverse_ssh_status':
                if (mode === Mode.EDIT) {
                    return {
                        true: t(TranslationsKeys.EDIT_FORM_ENABLE_LABEL),
                        false: t(TranslationsKeys.EDIT_FORM_DISABLE_LABEL),
                    };
                }
                return {
                    true: t(TranslationsKeys.SSL_TOGGLE_ENABLED_LABEL),
                    false: t(TranslationsKeys.SSL_TOGGLE_DISABLED_LABEL),
                };
            default:
                return null;
        }
    };
    const updateFormFields = (formData = {}, errorMessages = {}) => {
        const fieldsToShow = [];
        InitialSshConfig.forEach((config) => {
            const newConfig = config;
            newConfig.valueLabels = getAdditionlFieldAttribute(config);
            fieldsToShow.push({
                ...config,
                configCallback: getFieldConfig,
            });
        });
        const newFormFields = getFormFields(formData, fieldsToShow, errorMessages, mode);
        setSshFormFields(newFormFields);
    };
    const fetchSsh = () => {
        if (sshResponse && !isSshLoading && sshResponse.Data) {
            hideLoader();
            setSshData(sshResponse.Data);
        }
        else if (sshResponse && !isSshLoading && sshResponse.Error) {
            onError(t(TranslationsKeys.MESSAGE_API_FAILURE));
        }
    };
    useEffect(() => {
        fetchSsh();
    }, [sshResponse]);
    useEffect(() => {
        updateFormFields(sshData);
    }, [sshData, mode]);
    const onSave = (currentFormData) => {
        const postData = { ...parseFormData(currentFormData) };
        setSshPostData({ ...postData });
    };
    const onSaveSuccess = (response) => {
        setSshData(response?.Data || {});
        setFormType('');
        setMode(Mode.VIEW);
        onSuccess(t(TranslationsKeys.TOAST_SUCCESS));
    };
    const [updateSsh] = useSetRevSshMutation(response => onSaveSuccess(response), onError, sshPostData);
    useEffect(() => {
        if (sshPostData) {
            showLoader();
            updateSsh();
        }
    }, [sshPostData]);
    const actionHandler = (type, currentFormData = {}) => {
        switch (type) {
            case ActionButtons.EDIT:
                setFormType('ssh');
                setMode(Mode.EDIT);
                break;
            case ActionButtons.BACK:
            case ActionButtons.CANCEL:
                setMode(Mode.VIEW);
                break;
            case ActionButtons.SAVE:
                onSave(currentFormData);
                break;
            default:
                setMode(Mode.EDIT);
                break;
        }
    };
    const renderContent = () => {
        const config = {
            actions: [
                {
                    type: ActionButtons.EDIT,
                    title: t(TranslationsKeys.EDIT_BUTTON),
                },
            ],
            title: t(TranslationsKeys.SSH_TITLE),
            subTitle: t(TranslationsKeys.SSH_SUBTITLE),
            learnMoreKey: LearnMore.SSH,
            formFields: sshFormFields,
        };
        const actions = {
            primary: {
                type: ActionButtons.SAVE,
                text: t(TranslationsKeys.SAVE_BUTTON),
                returnData: true,
            },
            secondary: {
                type: ActionButtons.CANCEL,
                text: t(TranslationsKeys.CANCEL_BUTTON),
            },
        };
        const sshBannerAlertProps = {
            isVisible: mode === Mode.EDIT,
            type: BannerAlertType.WARNING,
            className: styles.sshBanner,
            message: t(TranslationsKeys.SSH_BANNER_ALERT_MESSAGE),
            showCloseButton: false,
            global: false,
            link: {
                label: t(TranslationsKeys.SSH_BANNER_ALERT_LINK_TEXT),
                openLinkInNewTab: true,
                link: 'https://docs.thoughtspot.com/master_20210301_5108d622c0/admin/setup/work-with-ts-support.html#set-up-a-reverse-tunnel-for-support',
            },
        };
        return (React.createElement(Content, { key: `ssh_${mode}`, config: config, mode: mode, pageName: pageName, backConfirm: true, actions: actions, banner: sshBannerAlertProps, actionHandler: actionHandler }));
    };
    if (isSshLoading || !sshResponse) {
        showLoader();
    }
    return (React.createElement("div", { className: styles.securityContainer, "data-testid": "ssh-container" },
        mode === Mode.VIEW && React.createElement(Seperator, null),
        (mode === Mode.VIEW || formType === 'ssh') && renderContent()));
};
//# sourceMappingURL=rev-ssh.container.js.map